import React, { useEffect, useState } from 'react';
import { AppBar, Toolbar, Box, Typography, Select, MenuItem, InputBase, Button, Stack, Container, IconButton, Drawer, List, ListItem, ListItemText, Paper, Avatar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import mainLogo from '../assets/main-logo.png';
import useResponsive from '../hooks/useResponsive';
import { fetchCategories, searchBooks } from '../services/Apis';
import { useFilter } from '../context/FilterContext';

const navItems = [
  { id: 'home', label: 'HOME', path: '/' },
  { id: 'about', label: 'ABOUT US', path: '/about' },

  { id: 'faq', label: "FAQ's", path: '/faq' },
  { id: 'blog', label: 'OUR BLOG', path: '/blog' },
  { id: 'contact', label: 'CONTACT US', path: '/contact' },
];

const drawerItems = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Contact Us', path: '/contact' },
  { label: 'Blog', path: '/blog' },

  { label: 'Faq', path: '/faq' },

];



const Navbar = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activePath, setActivePath] = useState(window.location.pathname)
  const [searchTitle, setSearchTitle] = useState('');
  const [, setSearchResults] = useState([]);

  // Add these states for auth
  const { profile, isLoggedIn } = useFilter(); // <-- Add this


  const handleNavClick = (path) => {
    setActivePath(path)
    navigate(path);
    setDrawerOpen(false);
  };

  const { isSmallScreen, isExtraSmall } = useResponsive()


  useEffect(() => {
    const getCategories = async () => {
      const cats = await fetchCategories();
      setCategories(cats);

      // if (cats.length > 0) {
      //   setSelectedCategory(cats[0].name);
      // }
    };
    getCategories();
  }, []);


  return (
    <>
      {/* Top Bar */}
      <AppBar position="sticky" sx={{ backgroundColor: '#fff', boxShadow: 'none', px: 0 }}>
        <Container sx={{ maxWidth: '1400px !important', px: 3 }}>
          <Toolbar disableGutters sx={{ justifyContent: 'space-between', minHeight: '80px !important' }}>
            {/* Logo */}

            <Box display="flex" alignItems="center" sx={{ cursor: 'pointer' }} onClick={() => navigate('/')}>
              <img loading='lazy' src={mainLogo} alt="Logo" style={{ height: isSmallScreen ? 40 : isExtraSmall ? 40 : 65, marginRight: -80 }} />
            </Box>


            {/* Search - hidden on xs */}
            <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', flex: 1, maxWidth: '650px', mx: 2 }}>
              <Select
                displayEmpty
                size="small"
                value={selectedCategory}
                onChange={(e) => setSelectedCategory(e.target.value)}
                renderValue={(selected) =>
                  selected === '' ? (
                    <span style={{ color: '#999' }}>Select Category</span>
                  ) : (
                    categories.find(cat => cat.id === selected)?.name || selected
                  )
                }
                sx={{
                  height: 44,
                  borderRight: 'none',
                  borderRadius: '4px 0 0 4px',
                  fontFamily: 'Poppins',
                  fontSize: 14,
                  fontWeight: 400,
                  minWidth: 170,
                  '& .MuiSelect-select': {
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  },
                  '& .MuiMenu-paper': {
                    '&::-webkit-scrollbar': {
                      display: 'none',
                    },
                    msOverflowStyle: 'none',
                    scrollbarWidth: 'none',
                  },
                }}
                MenuProps={{
                  PaperProps: {
                    sx: {
                      maxHeight: 300,
                      '&::-webkit-scrollbar': {
                        display: 'none',
                      },
                      msOverflowStyle: 'none',
                      scrollbarWidth: 'none',
                    },
                  },
                }}
              >
                <MenuItem disabled value="">
                  Select Category
                </MenuItem>
                {categories.map((cat) => (
                  <MenuItem key={cat.id} value={cat.id}>
                    {cat.name}
                  </MenuItem>
                ))}
              </Select>

              {/* Desktop Search Form */}
              <Box
                component="form"
                onSubmit={async (e) => {
                  e.preventDefault();
                  let payload = {};
                  if (selectedCategory) payload.categoryId = selectedCategory;
                  if (searchTitle) payload.title = searchTitle;
                  const results = await searchBooks(payload);
                  navigate('/result', { state: { books: results } });
                  // Reset search states after navigation
                  setSearchTitle('');
                  setSelectedCategory('');
                  setSearchResults([]);
                }}
                sx={{
                  display: 'flex', alignItems: 'center', border: '1px solid #ccc',
                  borderRadius: '0 4px 4px 0', overflow: 'hidden',
                  width: '100%', height: 42,
                  ml: 0
                }}
              >
                <InputBase
                  placeholder="Search Product. General Knowledge"
                  sx={{ px: 1, flex: 1, fontFamily: 'Poppins', fontSize: 14, fontWeight: 400, color: 'black' }}
                  value={searchTitle}
                  onChange={e => setSearchTitle(e.target.value)}
                />
                <IconButton
                  type="submit"
                  sx={{
                    backgroundColor: '#2e2e2e',
                    color: '#fff',
                    borderRadius: 0,
                    width: 100,
                    height: '100%',
                    gap: 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    // Remove hover effect
                    '&:hover': {
                      backgroundColor: '#2e2e2e'
                    }
                  }}
                >
                  <Typography variant="subtitle2" sx={{ fontWeight: 400 }}>
                    Search
                  </Typography>
                  <i className="fa fa-search" style={{ fontSize: 14 }}></i>
                </IconButton>
              </Box>
            </Box>

            {/* Right Icons */}
            <Box display="flex" alignItems="center" gap={1}>
              <Box sx={{ display: { xs: 'flex', md: 'flex' }, gap: 2 }}>
                {!isLoggedIn ? (
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: 'primary.main',
                      textTransform: 'none',
                      fontFamily: 'Poppins',
                      fontSize: 14,
                      fontWeight: 400,
                      boxShadow: 'none',
                      px: 3,
                      '&:hover': {
                        boxShadow: 'none'
                      },
                    }}
                    onClick={() => navigate('/login')}
                  >
                    Login
                  </Button>
                ) : (
                  <Box display="flex" alignItems="center" gap={2}>
                   {!isSmallScreen && <Box textAlign="right">
                      <Typography variant="body2" color="initial">Welcome</Typography>
                      <Typography
                        variant="body1"
                        sx={{
                          fontSize: 16,
                          fontWeight: 500,
                          color: "#000",
                          textAlign: "right",
                          lineHeight: 1,
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "150px" // or any width you want
                        }}
                      >
                        {profile?.name || "User"}
                      </Typography>

                    </Box>}


                    {profile?.image ? (
                      <Box
                        sx={{
                          width: 40,
                          height: 40,
                          borderRadius: '50%',
                          overflow: 'hidden',
                          bgcolor: "#ddd",
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >

                        <img
                          src={profile.image}
                          alt={profile.name || "User"}
                          onClick={() => navigate('/my-profile')}
                          style={{ width: '100%', height: '100%', objectFit: 'cover', cursor: 'pointer' }}
                        />

                      </Box>
                    ) : (
                      <Avatar onClick={() => navigate('/my-profile')} sx={{ width: 40, height: 40, bgcolor: "#ddd", color: "#000", cursor: 'pointer' }}>
                        {!profile.image && profile.name ? profile.name.charAt(0).toUpperCase() : null}
                      </Avatar>
                    )}
                  </Box>
                )}
                <i
                  className="fa-solid fa-bag-shopping"
                  style={{
                    fontSize: 24,
                    color: '#000',
                    cursor: 'pointer',
                    marginTop: '5px'
                  }}
                  onClick={() => navigate('/cart')}
                ></i>
              </Box>


              {/* Mobile menu icon */}
              <IconButton
                edge="end"
                sx={{ display: { xs: 'block', md: 'none' }, color: '#000', marginTop: '10px' }}
                onClick={() => setDrawerOpen(true)}
              >
                <MenuIcon />
              </IconButton>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Desktop Search Bar */}


      {/* Mobile Search Bar */}
      <Box sx={{ display: { xs: 'flex', md: 'none', lg: 'none' }, justifyContent: 'center', mb: 2 }}>
        <Paper
          component="form"
          onSubmit={async (e) => {
            e.preventDefault();
            const results = await searchBooks({
              categoryId: selectedCategory || "",
              title: searchTitle || "",
              priceMin: "",
              priceMax: "",
              language: "",
              discountOffer: ""
            });
            navigate('/result', { state: { books: results } });
            // Reset search states after navigation
            setSearchTitle('');
            setSelectedCategory('');
            setSearchResults([]);
          }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            borderRadius: '999px',
            overflow: 'hidden',
            width: '90%',
            border: '1px solid #ccc',
            height: '45px',
            boxShadow: 'none'
          }}
        >
          <InputBase
            placeholder="Search Product..."
            sx={{
              flex: 1,
              px: 2,
              fontSize: 14,
              fontFamily: 'Poppins',
            }}
            value={searchTitle}
            onChange={e => setSearchTitle(e.target.value)}
          />
          <IconButton
            type="submit"
            sx={{
              backgroundColor: 'primary.main',
              color: '#fff',
              borderRadius: 0,
              width: 70,
              height: '100%',
              // Remove hover effect
              '&:hover': {
                backgroundColor: 'primary.main'
              }
            }}
          >
            <i className="fa fa-search" style={{ fontSize: 14 }}></i>
          </IconButton>
        </Paper>
      </Box>

      {/* Bottom Navbar */}
      <Box sx={{ backgroundColor: '#E1AD1A', display: { xs: 'none', md: 'block', position: 'sticky', top: '80px', zIndex: '1000' } }}>
        <Container sx={{ maxWidth: '1400px !important', px: 3 }}>
          <Stack direction="row" spacing={3} alignItems="center" height={46}>
            {navItems.map((item) => (
              <Typography
                variant='h5'
                key={item.id}
                onClick={() => handleNavClick(item.path)}
                sx={{
                  color: activePath === item.path ? 'white' : '#fff',
                  px: 2.5,
                  py: 1.5,
                  cursor: 'pointer',
                  transition: 'background 0.2s, color 0.2s',
                  backgroundColor: activePath === item.path ? 'primary.main' : 'transparent',
                }}
              >
                {item.label}
              </Typography>
            ))}
          </Stack>
        </Container>
      </Box>

      {/* Drawer for small screen */}
      <Drawer
        anchor="top"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{ sx: { width: '100%' } }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            px: 2,
            py: 1
          }}
        >
          <img src={mainLogo} alt="Logo" style={{ height: 40 }} />
          <IconButton onClick={() => setDrawerOpen(false)}>
            <CloseIcon />
          </IconButton>
        </Box>

        <List>
          {drawerItems.map((item, index) => (
            <ListItem
              key={index}
              button
              onClick={() => {
                setActivePath(item.path);
                navigate(item.path);
                setDrawerOpen(false);
              }}
              selected={activePath === item.path}
              sx={{
                backgroundColor: activePath === item.path ? 'primary.main' : 'transparent',
                color: activePath === item.path ? '#fff' : '#000',
                '&:hover': {
                  backgroundColor: 'primary.main',
                  color: '#fff'
                },
                textAlign: 'center'
              }}
            >
              <ListItemText primary={item.label} sx={{ fontFamily: 'Poppins' }} />
            </ListItem>
          ))}
        </List>
      </Drawer>
    </>
  );
};

export default Navbar;